export const pizzaData = [
    {
        id: 11122,
        hidden: false,
        src: "roti.jpeg",
        name: "Roti Tawar",
        category: "item",
        price: 6000
    },
    {
        id: 111,
        hidden: false,
        src: "esduren.jpg",
        name: "Es Duren",
        category: "item",
        price: 5000
    },
    {
        id: 112,
        hidden: false,
        src: "espokat.jpg",
        name: "Es Pokat",
        category: "item",
        price: 5000
    },
    {
        id: 1111,
        hidden: false,
        src: "buah.jpg",
        name: "Buah Potong",
        category: "item",
        price: 2000
    },
    {
        id: 711,
        hidden: false,
        src: "laundry.jpg",
        name: "Laundry Baju",
        category: "item",
        price: 4000
    },
    {
        id: 777,
        hidden: false,
        src: "esbatu.png",
        name: "Es Batu",
        category: "item",
        price: 1000
    },
    {
        id: 11110,
        hidden: false,
        src: "gojek.jpg",
        name: "Antar Motor 3,5 KM",
        category: "item",
        price: 7000
    },
    {
        id: 111100,
        hidden: false,
        src: "gocar.png",
        name: "Antar Mobil 3 KM",
        category: "item",
        price: 10000
    },
    {
        id: 1111000,
        hidden: false,
        src: "gosend.jpg",
        name: "Anter Jemput Paket Dalam Kota 3,5 KM",
        category: "item",
        price: 10000
    },
    {
        id: 1112,
        hidden: false,
        src: "pempek.jpg",
        name: "Pempek",
        category: "item",
        price: 1000
    },
    {
        id: 1,
        hidden: false,
        src: "susu-kedelai.jpg",
        name: "Susu Kedelai",
        category: "item",
        price: 2000
    },
    {
        id: 2,
        hidden: false,
        src: "sari-kacang-hijau.jpg",
        name: "Sari Kacang Hijau",
        category: "item",
        price: 2000
    },
    {
        id: 3,
        hidden: false,
        src: "jus-pokat.jpg",
        name: "Jus Pokat",
        category: "item",
        price: 5000
    },
    {
        id: 4,
        hidden: false,
        src: "jus-buah-naga.jpg",
        name: "Jus Buah Naga",
        category: "item",
        price: 5000
    },
    {
        id: 5,
        hidden: false,
        src: "tahu.jpg",
        name: "Tahu",
        category: "item",
        price: 2000
    },
    {
        id: 6,
        hidden: false,
        src: "tempe.jpg",
        name: "Tempe",
        category: "item",
        price: 2000
    },
    {
        id: 7,
        hidden: false,
        src: "pisang-goreng.jpg",
        name: "Pisang Goreng",
        category: "item",
        price: 1000
    },
    {
        id: 6,
        hidden: false,
        src: "tahu-sumedang.jpg",
        name: "Tahu Sumedang",
        category: "item",
        price: 1000
    },
    {
        id: 8,
        hidden: false,
        src: "steam-motor.jpg",
        name: "Cuci Motor",
        category: "item",
        price: 15000
    },
    {
        id: 9,
        hidden: false,
        src: "steam-mobil.jpg",
        name: "Cuci Mobil",
        category: "item",
        price: 25000
    },
    {
        id: 10,
        hidden: false,
        src: "laundry-sepatu.jpg",
        name: "Cuci Sepatu",
        category: "item",
        price: 10000
    },
    {
        id: 11,
        hidden: false,
        src: "burger.jpg",
        name: "Burger",
        category: "item",
        price: 5000
    },
    {
        id: 12,
        hidden: false,
        src: "sandwich.jpg",
        name: "Sandwich",
        category: "item",
        price: 3000
    },
    {
        id: 13,
        hidden: false,
        src: "roti-bakar-mini.jpg",
        name: "Roti Bakar Mini",
        category: "item",
        price: 2000
    },
    {
        id: 14,
        hidden: false,
        src: "/buku/1BankSoalCPNS.jpg",
        name: "Buku Bank Soal CPNS",
        category: "book",
        link: 'https://docs.google.com/document/d/1AaiIru_yl5u_qDvSkv4zFXOvA8HXrFs0eEWAalUcLJo/edit?usp=sharing'
    },
    {
        id: 15,
        hidden: false,
        src: "/buku/2BankSoalSKBCPNS.jpg",
        name: "Buku Bank Soal SKB CPNS",
        category: "book",
        link: 'https://docs.google.com/document/d/1X1nixSZPpOLr1i19C8ULFpMfu0AED5TVpsdrXJalipU/edit?usp=sharing'
    },
    {
        id: 16,
        hidden: false,
        src: "/buku/3BankSoalTKDBUMN.jpg",
        name: "Buku Bank Soal TKD BUMN",
        category: "book",
        link: 'https://docs.google.com/document/d/1xrMA9EzmzZYxSKB3kG3Pk6kQ1vxiQ72ugzx61VkSYLc/edit?usp=sharing'
    },
    {
        id: 17,
        hidden: false,
        src: "/buku/4BankSoalBInggrisBUMN.jpg",
        name: "Buku Bank Soal B Inggris BUMN",
        category: "book",
        link: 'https://docs.google.com/document/d/1st-ImsBquNqM5nF-Sq0y2v6LBdCjZB9b6lvsSVo2vGo/edit?usp=sharing'
    },
    {
        id: 18,
        hidden: false,
        src: "/buku/5BankSoalTPA.jpg",
        name: "Buku Bank Soal TPA",
        category: "book",
        link: 'https://docs.google.com/document/d/1leDT51j7HAKZZj40AxIJZSWWlAQw2w3A5Czor7X8gZ4/edit?usp=sharing'
    },
    {
        id: 19,
        hidden: false,
        src: "/buku/7BankSoalUTULUGM.jpg",
        name: "Buku Bank Soal UTUL UGM",
        category: "book",
        link: 'https://docs.google.com/document/d/1k8Ncr1ZN98LVU8KQPJHE7F1SPn4MkVAkI161COiaEq8/edit?usp=sharing'
    },
    {
        id: 20,
        hidden: false,
        src: "/buku/8BankSoalMandarin.jpg",
        name: "Buku Bank Soal Mandarin",
        category: "book",
        link: 'https://docs.google.com/document/d/1CAXkJq7qDXzvc8yud_EXeW2ridn2WR7z1TGGu-UU958/edit?usp=sharing'
    },
    {
        id: 21,
        hidden: false,
        src: "/buku/9BankSoalJerman.jpg",
        name: "Buku Bank Soal Jerman",
        category: "book",
        link: 'https://docs.google.com/document/d/1IyE4_seiolVa6T9cVRMZyXSGgAe0xJ0y0_WKtKkUKRA/edit?usp=sharing'
    },
    {
        id: 22,
        hidden: false,
        src: "/buku/10BankSoalMasukKerja.jpg",
        name: "Buku Bank Soal Masuk Kerja",
        category: "book",
        link: 'https://docs.google.com/document/d/1tInFWl9jr_okoiCpgdHj90q92Nq5nY87AFqdgExBpe8/edit?usp=sharing'
    },
    {
        id: 23,
        hidden: false,
        src: "/buku/11BankSoalMatematika.png",
        name: "Buku Bank Soal Matematika",
        category: "book",
        link: 'https://docs.google.com/document/d/1BeMWxhBIKRGDsPcEV0NXnBGZ3ucLN4EwZMQzbu4w2rM/edit?usp=sharing'
    },
    {
        id: 24,
        hidden: false,
        src: "/buku/12AlgoritmaPemogramanBaru.png",
        name: "Buku Algoritma Pemograman",
        category: "book",
        link: 'https://docs.google.com/document/d/1JnEy8XmZlMqWkjVG3S0q-j4G5ZMk2OBbtCjty-Hoe2w/edit?usp=sharing'
    },
    {
        id: 25,
        hidden: false,
        src: "cuci-ac.jpg",
        name: "Cuci AC",
        category: "item",
        price: 70000
    },
    {
        id: 26,
        hidden: false,
        src: "catdanlas.jpeg",
        name: "Cat Las",
        category: "item",
        price: 150000
    },
    {
        id: 27,
        hidden: false,
        src: "recover-sofa.jpg",
        name: "Service Sofa",
        category: "item",
        price: 100000
    },
    {
        id: 28,
        hidden: false,
        src: "service carpet.jpeg",
        name: "Cuci Bersih Ambal, Karpet, Spring Bed, Bed Cover dan Sofa",
        category: "item",
        price: 50000
    },
    {
        id: 29,
        hidden: false,
        src: "pesawatkeretatravelbus.jpeg",
        name: "Travel, Bus, Kereta Api dan Pesawat",
        category: "item",
        price: 100000
    },
    {
        id: 30,
        hidden: false,
        src: "Home-Stay-penginapan-yang-berada-di-tepian-Danau-Ranau-Minggu-2562023.jpg",
        name: "Home Stay Ranau",
        category: "item",
        price: 100000
    },
    {
        id: 31,
        hidden: false,
        src: "rental.jpg",
        name: "Rental Motor Dan Mobil",
        category: "item",
        price: 100000
    },
    {
        id: 32,
        hidden: false,
        src: "servicekendaraan.jpeg",
        name: "Service Motor dan Mobil",
        category: "item",
        price: 50000
    },
    {
        id: 33,
        hidden: false,
        src: "download.jpeg",
        name: "Photo Copy, Jilid, Vinil Dan ATK",
        hidden: false,category: "item",

        price: 150
    },
    {
        id: 34,
        hidden: false,
        src: "arang.jpg",
        name: "Arang",
        category: "item",
        price: 5000
    },
    {
        id: 35,
        hidden: false,
        src: "jemuran.jpeg",
        name: "Jemuran",
        category: "item",
        price: 400000
    },
    {
        id: 36,
        hidden: false,
        src: "service-laptop.jpg",
        name: "Service Laptop/Komputer/Handphone/Printer",
        category: "item",
        price: 50000
    },
    {
        id: 37,
        hidden: false,
        src: "charge-aki.png",
        name: "Cas dan Service Aki",
        category: "item",
        price: 20000
    },
    {
        id: 38,
        hidden: false,
        src: "ban.png",
        name: "Pasang Ban Motor dan Mobil",
        category: "item",
        price: 150000
    },
    {
        id: 39,
        hidden: false,
        src: "kue-kering.png",
        name: "Aneka Kue Kering",
        category: "item",
        price: 30000
    },
    {
        id: 40,
        hidden: false,
        src: "/buku/13tni-polri.png",
        name: "Buku Test TNI Polri",
        category: "book",
        link: "https://docs.google.com/document/d/19R4R3xC0WAZ6HJK5ui1vDUojmYUPufRxCFXPafwGj9o/edit?usp=sharing"
    },
    {
        id: 41,
        hidden: false,
        src: "/buku/14kesemaptaanjasmani.png",
        name: "Buku Kesemaptaan Jasmani",
        category: "book",
        link: "https://docs.google.com/document/d/1vqym-KyRJ5AZuGneX3hSsMhmiuOaoBqj7BLyitjYBIw/edit?usp=sharing"
    },
    {
        id: 42,
        hidden: false,
        src: "topup.jpg",
        name: "Topup E-Wallet",
        category: "item",
        price: 1000
    },
    {
        id: 43,
        hidden: false,
        src: "token.jpg",
        name: "Isi Token",
        category: "item",
        price: 1000
    },
    {
        id: 44,
        hidden: false,
        src: "pulsa.png",
        name: "Isi Pulsa",
        category: "item",
        price: 1000
    },
    {
        id: 45,
        hidden: false,
        src: "crocs.png",
        name: "Sepatu Sandal Crocs Murah",
        category: "item",
        price: 50000
    },
    {
        id: 46,
        hidden: false,
        src: "savilo.png",
        name: "Sendal Savilo",
        category: "item",
        price: 15000
    },
    {
        id: 47,
        hidden: false,
        src: "swallow.png",
        name: "Sendal Swallow",
        category: "item",
        price: 11000
    },
    {
        id: 48,
        hidden: false,
        src: "website.jpg",
        name: "Pembuatan Hosting, Website Dan Mobile",
        category: "item",
        price: 300000
    },
    {
        id: 49,
        hidden: false,
        src: "/buku/15bukuboostupenglish.jpg",
        name: "Buku Kembangkan Englishmu",
        category: "book",
        link: 'https://docs.google.com/document/d/1keYA166vKFo4vtjLEoqAi1TxP9vcrN9r1hW8gTDe_q8/edit?usp=sharing'
    },
    {
        id: 50,
        hidden: false,
        src: "pisang.jpg",
        name: "Pisang",
        category: "item",
        price: 15000
    },
    {
        id: 51,
        hidden: false,
        src: "ubi.jpg",
        name: "Ubi",
        category: "item",
        price: 10000
    },
    {
        id: 52,
        hidden: false,
        src: "pisang-goreng.jpg",
        name: "Pisang Goreng",
        category: "item",
        price: 1000
    },
    {
        id: 53,
        hidden: false,
        src: "tahu-goreng.jpeg",
        name: "Tahu Goreng",
        category: "item",
        price: 1000
    },
    {
        id: 54,
        hidden: false,
        src: "pempek-goreng.jpg",
        name: "Pempek Goreng",
        category: "item",
        price: 1000
    },
    {
        id: 55,
        hidden: false,
        src: "ubi-goreng.jpg",
        name: "Ubi Goreng",
        category: "item",
        price: 1000
    },
    {
        id: 56,
        hidden: false,
        src: "oli.jpg",
        name: "Oli",
        category: "item",
        price: 30000
    },
    {
        id: 57,
        hidden: false,
        src: "roti2000.png",
        name: "Roti 2000",
        category: "item",
        price: 2000
    },
    {
        id: 58,
        hidden: false,
        src: "rotibandung5000.png",
        name: "Roti Bakar Bandung",
        category: "item",
        price: 5000
    },
    {
        id: 59,
        hidden: false,
        src: "rotigepeng2000.png",
        name: "Roti Gepeng 2000",
        category: "item",
        price: 30000
    },
    {
        id: 60,
        hidden: false,
        src: "roti5000.png",
        name: "Roti  2000",
        category: "item",
        price: 20000
    },
    {
        id: 61,
        hidden: false,
        src: "/buku/15bukuboostupenglish.jpg",
        name: "Buku OJK",
        category: "book",
        link: 'https://docs.google.com/document/d/1keYA166vKFo4vtjLEoqAi1TxP9vcrN9r1hW8gTDe_q8/edit?usp=sharing'
    },
    {
        id: 62,
        hidden: false,
        src: "ayam.jpeg",
        name: "Nasi Ayam Bakar",
        category: "item",
        price: 10000
    },
    {
        id: 63,
        hidden: false,
        src: "dendeng.jpeg",
        name: "Nasi Dendeng",
        category: "item",
        price: 10000
    },
    {
        id: 64,
        hidden: false,
        src: "ikan.jpeg",
        name: "Ikan Bakar",
        category: "item",
        price: 10000
    },
    {
        id: 65,
        hidden: false,
        src: "rendang.jpeg",
        name: "Nasi Rendang",
        category: "item",
        price: 10000
    },
    {
        id: 66,
        hidden: false,
        src: "/buku/16techstack.jpg",
        name: "Buku Tech Stack New Year",
        category: "book",
        link: "https://rwp.vercel.app/"
    },
    {
        id: 67,
        hidden: false,
        src: "/buku/17computervision.jpg",
        name: "Buku Computer Vision",
        category: "book",
        link: "https://docs.google.com/document/d/16-khy7kJnnI-Gk8iWb13W3jMuMVGOxHAk9xm5M04_ms/edit?usp=sharing"
    },
    {
        id: 68,
        hidden: false,
        src: "/buku/18deeplearning.jpg",
        name: "Buku Deep Learning",
        category: "book",
        link: "https://docs.google.com/document/d/16-khy7kJnnI-Gk8iWb13W3jMuMVGOxHAk9xm5M04_ms/edit?usp=sharing"
    },
    {
        id: 69,
        hidden: false,
        src: "/buku/19iot.jpg",
        name: "Buku IoT",
        category: "book",
        link: "https://docs.google.com/document/d/16-khy7kJnnI-Gk8iWb13W3jMuMVGOxHAk9xm5M04_ms/edit?usp=sharing"
    },
    {
        id: 70,
        hidden: false,
        src: "/buku/20arduinosensormove.jpg",
        name: "Buku Arduino Sensor",
        category: "book",
        link: "https://docs.google.com/document/d/16-khy7kJnnI-Gk8iWb13W3jMuMVGOxHAk9xm5M04_ms/edit?usp=sharing"
    },
    {
        id: 71,
        hidden: false,
        src: "/buku/21webportofolio.jpg",
        name: "Buku Membuat Web Portofolio",
        category: "book",
        link: "https://docs.google.com/document/d/16-khy7kJnnI-Gk8iWb13W3jMuMVGOxHAk9xm5M04_ms/edit?usp=sharing"
    },
    {
        id: 72,
        hidden: false,
        src: "/buku/22bigdata.jpg",
        name: "Buku Big Data",
        category: "book",
        link: "https://docs.google.com/document/d/16-khy7kJnnI-Gk8iWb13W3jMuMVGOxHAk9xm5M04_ms/edit?usp=sharing"
    },
    {
        id: 73,
        hidden: false,
        src: "/buku/23posandwarehouse.jpg",
        name: "Buku Membuat Pos and Warehouse",
        category: "book",
        link: "https://docs.google.com/document/d/16-khy7kJnnI-Gk8iWb13W3jMuMVGOxHAk9xm5M04_ms/edit?usp=sharing"
    },
    {
        id: 74,
        hidden: false,
        src: "/buku/24newsletter.jpg",
        name: "Buku Membuat Website Newsletter",
        category: "book",
        link: "https://docs.google.com/document/d/16-khy7kJnnI-Gk8iWb13W3jMuMVGOxHAk9xm5M04_ms/edit?usp=sharing"
    },
    {
        id: 75,
        hidden: false,
        src: "/buku/25deliveryandgroceries.jpg",
        name: "Buku Delivery And Groceries",
        category: "book",
        link: "https://docs.google.com/document/d/16-khy7kJnnI-Gk8iWb13W3jMuMVGOxHAk9xm5M04_ms/edit?usp=sharing"
    },
    {
        id: 76,
        hidden: false,
        src: "ubitape.png",
        name: "Ubi Tape 1/2 Kg",
        category: "item",
        price: 7000
    },
    {
        id: 77,
        hidden: false,
        src: "kebun/anggur.jpg",
        name: "Anggur 1 Kg",
        category: "item",
        price: 40000
    },
    {
        id: 78,
        hidden: false,
        src: "kebun/belewa.jpeg",
        name: "Belewa 1 Kg",
        category: "item",
        price: 30000
    },
    {
        id: 79,
        hidden: false,
        src: "kebun/bengkoang.jpg",
        name: "Bengkoang 1 Kg",
        category: "item",
        price: 17000
    },
    {
        id: 80,
        hidden: false,
        src: "kebun/strawberry.jpeg",
        name: "Strawberry 1 Kg",
        category: "item",
        price: 23000
    },
    {
        id: 81,
        hidden: false,
        src: "kebun/cabe.jpg",
        name: "Cabe 1 Kg",
        category: "item",
        price: 90000
    },
    {
        id: 82,
        hidden: false,
        src: "kebun/duren.jpg",
        name: "Duren Premium",
        category: "item",
        price: 40000
    },
    {
        id: 83,
        hidden: false,
        src: "kebun/kangkung.jpg",
        name: "Kangkung 1 Ikat",
        category: "item",
        price: 3500
    },
    {
        id: 84,
        hidden: false,
        src: "kebun/kates.jpg",
        name: "Kates",
        category: "item",
        price: 15000
    },
    {
        id: 85,
        hidden: false,
        src: "kebun/melon.png",
        name: "Melon 1 Kg",
        category: "item",
        price: 30000
    },
    {
        id: 86,
        hidden: false,
        src: "kebun/alpukat.jpg",
        name: "Pokat 1 Kg",
        category: "item",
        price: 250000
    },
    {
        id: 87,
        hidden: false,
        src: "kebun/ubi.jpeg",
        name: "Ubi 1 Kg",
        category: "item",
        price: 10000
    },
    {
        id: 88,
        hidden: false,
        src: "kebun/wortel.jpg",
        name: "Wortel 1 Kg",
        category: "item",
        price: 19000
    },
    {
        id: 89,
        hidden: false,
        src: "ternak/ayampecking.jpg",
        name: "Ayam Potong Pecking 1 Kg",
        category: "item",
        price: 44000
    },
    {
        id: 90,
        hidden: false,
        src: "ternak/bebek.png",
        name: "Bebek Pecking 1,1 Kg",
        category: "item",
        price: 60000
    },
    {
        id: 91,
        hidden: false,
        src: "ternak/dagingsapi.jpg",
        name: "Daging Sapi  Super 1 Kg",
        category: "item",
        price: 115000
    },
    {
        id: 92,
        hidden: false,
        src: "ternak/ikantuna.jpg",
        name: "Ikan Tuna 1 Kg",
        category: "item",
        price: 76000
    },
    {
        id: 93,
        hidden: false,
        src: "ternak/daging-kambing.jpg",
        name: "Daging Kambing Super Frozen 1 Kg",
        category: "item",
        price: 175000
    },
    {
        id: 94,
        hidden: false,
        src: "laut/daging-kambing.jpg",
        name: "Daging Kambing Super Frozen 1 Kg",
        category: "item",
        price: 175000
    },
    {
        id: 95,
        hidden: false,
        src: "laut/cumi.jpg",
        name: "Cumi Segar 1 Kg",
        category: "item",
        price: 120000
    },
    {
        id: 96,
        hidden: false,
        src: "laut/ikansarden.jpg",
        name: "Ikan Sarden Laut 1 Kg",
        category: "item",
        price: 20000
    },
    {
        id: 97,
        hidden: false,
        src: "laut/kepiting.jpg",
        name: "Kepiting Rajungan Besar 1 Kg Isi 5-7",
        category: "item",
        price: 115000
    },
    {
        id: 98,
        hidden: false,
        src: "laut/udang.jpg",
        name: "Udang Vaname 1 Kg",
        category: "item",
        price: 105000
    },
    {
        id: 99,
        hidden: false,
        src: "bebek-madura.jpeg",
        name: "nasi Bebek Madura ",
        category: "item",
        price: 12000
    },
    {
        id: 100,
        hidden: false,
        src: "buburayam.jpg",
        name: "Bubur Ayam ",
        category: "item",
        price: 8000
    },
    {
        id: 101,
        hidden: false,
        src: "nasiuduk.jpg",
        name: "Nasi Uduk",
        category: "item",
        price: 8000
    },
    {
        id: 102,
        hidden: false,
        src: "martabakmanis.jpg",
        name: "Martabak Manis",
        category: "item",
        price: 10000
    },
    {
        id: 103,
        hidden: false,
        src: "martabaktelor.jpg",
        name: "Martabak telor",
        category: "item",
        price: 10000
    },
    {
        id: 104,
        hidden: false,
        src: "/buku/26videosumarization.jpg",
        name: "Video Summarization",
        category: "book",
        link: "https://docs.google.com/document/d/1lcXAhJWCs8b9DTwPUaO2KHG53n0Y8QFiRZuHYFw6n18/edit?usp=sharing"
    },
    {
        id: 105,
        hidden: false,
        src: "/buku/27speech-recogniton.jpg",
        name: "Speech Recognition",
        category: "book",
        link: "https://docs.google.com/document/d/1MBctxofrkWrKJmcT5S4S8kBJrsF_U139bMasYlnKOOg/edit?usp=sharing"
    },
    {
        id: 106,
        hidden: false,
        src: "/quizz/quizz.png",
        name: "Quiz Part 1 2025",
        category: "book",
        link: "https://quiz-wa-eight.vercel.app/submit/3280ae92-7b77-47f3-9996-4e19af0f811a"
    },
    {
        id: 107,
        hidden: false,
        src: "/buku/28reinforcement_learning.jpg",
        name: "Reinforcement Learning",
        category: "book",
        link: "https://docs.google.com/document/d/1Jj2NqqwKSFYTVjbkct0rFiIo4ddb44DudkBY6nGYboI/edit?usp=sharing"
    },
    {
        id: 108,
        hidden: false,
        src: "/buku/29diary.jpg",
        name: "Diary Updage Toefl and Ielts",
        category: "book",
        link: "https://docs.google.com/document/d/1EFJ4Z7LzRaO4RXZlXLRnLW2pleN8JlfhrMeWk9eJWsE/edit?usp=sharing"
    },
    {
        id: 109,
        hidden: false,
        src: "/buku/30gooddesign.jpg",
        name: "Good Design Architecture Principle Software",
        category: "book",
        link: "https://docs.google.com/document/d/1ySd3a_OCgZ90FJpLq0ZluuOYift0v8-y3O4FnL3oU5E/edit?usp=sharing"
    },
    {
        id: 110,
        hidden: false,
        src: "ikanlele.jpg",
        name: "Ikan Lele 1 kg",
        category: "item",
        price: 33000
    },
    {
        id: 111,
        hidden: false,
        src: "ikanila.jpg",
        name: "Ikan Nila 1 kg",
        category: "item",
        price: 43000
    },
    {
        id: 112,
        hidden: false,
        src: "ikanbawal.jpg",
        name: "Ikan Bawal 1 kg",
        category: "item",
        price: 40000
    },
    {
        id: 113,
        hidden: false,
        src: "ikanpatin.jpg",
        name: "Ikan Patin 1 kg",
        category: "item",
        price: 50000
    },
    {
        id: 114,
        hidden: false,
        src: "ikangurami.jpg",
        name: "Ikan Gurami 1 kg",
        category: "item",
        price: 59000
    },
    {
        id: 115,
        hidden: false,
        src: "/sabun/detergen_bubuk.png",
        name: "Detergen Bubuk 1 kg",
        category: "item",
        price: 10000
    },
    {
        id: 116,
        hidden: false,
        src: "/sabun/detergen_cair.jpg",
        name: "Detergen Cair 1 ltr",
        category: "item",
        price: 6000
    },
    {
        id: 117,
        hidden: false,
        src: "/sabun/handbody.jpeg",
        name: "Handbody 300ml",
        category: "item",
        price: 10000
    },
    {
        id: 118,
        hidden: false,
        src: "/sabun/parfume.jpg",
        name: "Parfume 30ml",
        category: "item",
        price: 4000
    },
    {
        id: 119,
        hidden: false,
        src: "/sabun/pasta_gigi.png",
        name: "Pepsodent/Pasta Gigi 120gr",
        category: "item",
        price: 6000
    },
    {
        id: 119,
        hidden: false,
        src: "/sabun/sabun_batangan.png",
        name: "Sabun Batangan",
        category: "item",
        price: 2000
    },
    {
        id: 120,
        hidden: false,
        src: "/sabun/sabun_mandi_cair.jpg",
        name: "Sabun Mandi Cair 1 lt",
        category: "item",
        price: 10000
    },
     {
        id: 121,
        hidden: false,
        src: "/sabun/sabun-cuci-piring.jpg",
        name: "Sabun Cuci Piring 450 ml",
        category: "item",
        price: 3000
    },
    {
        id: 122,
        hidden: false,
        src: "/sabun/sampo_mandi.png",
        name: "Shampo Anti Dandruff Extra Harum Original Aroma Segar Kemasan 1 Liter",
        category: "item",
        price: 16000
    },
    {
        id: 123,
        hidden: false,
        src: "/sabun/sampo_mobil.jpg",
        name: "Shampo/Sabun Cuci Mobil dan Motor 1 Liter",
        category: "item",
        price: 7000
    }
]